import React, {useEffect} from 'react';
import {SelectInput} from '../utils/SelectInput';
import {prepareOptions, responseSelector} from '../utils/utils';
import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {log} from '../utils/logs';
import {getUsuariosDuck, getUsuariosThunk} from '../oportunidades/duck';

export const UsuarioSelect = ({
  token,
  usuarioOption,
  setUsuarioOption,
  onError,
  hint,
}) => {
  const dispatch = useDispatch();

  const modelUsuarios = useSelector(state => state.getUsuarios);

  const [usuariosLoadStatus, setUsuariosLoadStatus] = useState('IDLE');
  const [usuariosOptions, setUsuariosOptions] = useState();

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(modelUsuarios);

    if (error) {
      onError(errorMessage);

      dispatch(getUsuariosDuck.actions.clear());
    }

    if (data) {
      log({'modelUsuarios.useEffect.data': data});

      const mUsuariosOptions = prepareOptions(data.items);
      log({mUsuariosOptions});

      setUsuariosOptions(mUsuariosOptions);

      setUsuariosLoadStatus('LOADED');
      dispatch(getUsuariosDuck.actions.clear());
    }
  }, [modelUsuarios]);

  useEffect(() => {
    setUsuariosLoadStatus('LOADING');
    dispatch(
      getUsuariosThunk({
        userToken: token.raw,
      }),
    );
  }, []);

  return (
    <SelectInput
      label="Usuario"
      hint={hint}
      value={usuarioOption}
      options={usuariosOptions}
      setValue={setUsuarioOption}
      disabled={usuariosLoadStatus !== 'LOADED'}
      isLoading={usuariosLoadStatus !== 'LOADED'}
    />
  );
};
